import React from 'react';
import { formatMs } from '../utils/time';

const ResultadoDetailTablaRankings = (props) => (
  <div className="w-full pb-6">
    <div className="mx-auto max-w-5xl px-4 md:px-40">
      {(props.rankingsResultados && props.rankingsResultados.length) ? (
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="border-b border-slate-700">
                <th className="text-left py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                  Ranking
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                  Pos.
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                  Tiempo
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                  P.Sexo
                </th>
                <th className="text-right py-3 px-4 text-sm font-semibold text-slate-300 font-montserrat">
                  P.Cat.
                </th>
              </tr>
            </thead>
            <tbody>
              {props.rankingsResultados.map(r => (
                <tr key={r.id} className="border-b border-slate-800 hover:bg-slate-900/30 transition">
                  <td className="py-3 px-4 text-white font-medium font-montserrat text-sm">
                    {r.ranking_header}
                  </td>
                  <td className="text-right py-3 px-4 text-white font-semibold font-montserrat text-sm">
                    {r.puesto}
                  </td>
                  <td className="text-right py-3 px-4 text-white font-mono text-sm">
                    {formatMs(r.valor)}
                  </td>
                  <td className="text-right py-3 px-4 text-slate-300 font-montserrat text-sm">
                    {r.sexo}-{r.puesto_sexo}
                  </td>
                  <td className="text-right py-3 px-4 text-slate-300 font-montserrat text-sm">
                    {r.categoria_codigo ? (
                      <span>{r.categoria_codigo}-{r.puesto_categoria}</span>
                    ) : (
                      <span>{r.puesto_categoria}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center py-12">
          <div className="text-slate-400 font-montserrat text-base">
            No hay datos disponibles
          </div>
        </div>
      )}
    </div>
  </div>
);

export default ResultadoDetailTablaRankings;